import React from 'react';
import { i18next, utils, view } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import optionTypes from '../constants/option-types';
import previewGifs from '../constants/preview-gifs';

const { Paragraph, Icon } = designSystem;

const SLIDER_MIN = 0;
const SLIDER_MAX = 128;
const SLIDER_STEP = 1;

const DEFAULT_PROPERTY = '--ws-media-container-border-radius';
const FALLBACK_VALUE = 0;

const normalizeValue = (value) => parseFloat(value);
const transformValue = (value) => `${value}px`;

const computeFallbackValue = () => {
  const liveDom = view.accessors.getLiveDocument();

  const defaultValue = getComputedStyle(liveDom.documentElement).getPropertyValue(DEFAULT_PROPERTY);

  if (!defaultValue) return FALLBACK_VALUE;

  const normalizedValue = normalizeValue(defaultValue);

  return utils.isNumeric(normalizedValue) ? normalizedValue : FALLBACK_VALUE;
};

const CORNERS = [
  {
    id: 'top-left-corner',
    iconGlyph: 'corner-top-left-radius',
    property: '--ws-media-container-custom-border-top-left-radius',
  },
  {
    id: 'top-right-corner',
    iconGlyph: 'corner-top-right-radius',
    property: '--ws-media-container-custom-border-top-right-radius',
  },
  {
    id: 'bottom-left-corner',
    iconGlyph: 'corner-bottom-left-radius',
    property: '--ws-media-container-custom-border-bottom-left-radius',
  },
  {
    id: 'bottom-right-corner',
    iconGlyph: 'corner-bottom-right-radius',
    property: '--ws-media-container-custom-border-bottom-right-radius',
  },
];

const getPopoverProps = ({ imgSrc, iconGlyph }) => ({
  imgSrc,
  renderContent: () => (
    <Paragraph appearance="white" size="small">
      {i18next.t('Adjust corners for media')}. {i18next.t('Click the {icon}', { icon: '' })}{' '}
      <Icon type="white" size={16} strokeWidth={2} glyph={iconGlyph} insideText />
      {i18next.t('{click_the_icon} to adjust each one separately', { click_the_icon: '' })}
    </Paragraph>
  ),
});

const getMediaCornersSettings = () => ({
  id: 'media-corners',
  type: optionTypes.SLIDER,
  title: i18next.t('Independent corners'),
  mixedLabel: i18next.t('Mixed'),
  iconGlyph: 'corner-radius',
  step: SLIDER_STEP,
  min: SLIDER_MIN,
  max: SLIDER_MAX,
  popover: getPopoverProps({
    imgSrc: previewGifs.MEDIA_CORNERS_GIF,
    iconGlyph: 'corner-radius',
  }),
  normalizeValue,
  transformValue,
  computeFallbackValue,
  options: CORNERS,
});

export default getMediaCornersSettings;
